import { action } from 'easy-peasy';
import { IActionSetAiAssistNoteAssist } from '../types';

const setNoteAssist: IActionSetAiAssistNoteAssist = action((state, payload) => {
  state.noteAssist = payload;
});

export default setNoteAssist;
